import React from 'react';
import { Link } from 'react-router5';

import { FEED, SEARCH } from '$shared/constants/pages';
import { Button, LottieIcon, Placeholder } from '$uikit';
import { useTranslator } from '$hooks';

export const EmptyPlaceholder = () => {
  const t = useTranslator();
  return (
    <Placeholder
      title={t('feed_empty_title')}
      icon={<LottieIcon name="news" />}
      iconSize={120}
      actions={
        <Link routeName={FEED} routeParams={{ section: 'smart' }}>
          <Button size="small">{t('feed_show_peoples')}</Button>
        </Link>
      }
    >
      {t('feed_empty_caption')}
    </Placeholder>
  );
};
